var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import EventEmitter from "events";
import { DataTrackingClient } from "../core";
import { Logger } from "../utils/logger";
import { Utility } from "../utils/utility";
export class FetchInterceptor {
    constructor() {
        this._emitter = new EventEmitter();
        this._trackingItems = [];
        if (FetchInterceptor._instance) {
            throw new Error("Singleton class [FetchInterceptor] can't be instantiated more than once. Call getInstance() instead");
        }
        this._originalFetch = window.fetch;
    }
    static getInstance() {
        if (!FetchInterceptor._instance) {
            FetchInterceptor._instance = new FetchInterceptor();
        }
        return FetchInterceptor._instance;
    }
    addItem(objTrackingItem) {
        Logger.verbose("FetchInterceptor Adding tracking item => ", objTrackingItem);
        this._trackingItems.push(objTrackingItem);
    }
    on(eventName, callBack) {
        this._emitter.on(eventName, (e) => {
            callBack.call(this, e);
        });
    }
    _analyzeFetchResponse(response, url, method, body) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // Read response text
                const responseText = yield response.text();
                // Create a mock fetch request object for consistency with tracking logic
                const mockFetchRequest = {
                    _requestUrl: url,
                    _requestMethod: method,
                    _data: body,
                    responseText: responseText
                };
                let trackingItem = this._ifNeedToTrack(mockFetchRequest);
                if (trackingItem) {
                    Logger.verbose("Matched tracking element => ", trackingItem);
                    this._emitter.emit("complete", {
                        xhr: mockFetchRequest,
                        response: response,
                        item: trackingItem
                    });
                }
                else {
                    Logger.info("No matching element was found. Not triggering fetch complete.");
                }
            }
            catch (error) {
                Logger.error("Error reading fetch response text");
                Logger.error(error);
            }
        });
    }
    init() {
        const fetchInterceptor = this;
        const originalFetch = this._originalFetch;
        window.fetch = function (input, init) {
            const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
            const method = (init === null || init === void 0 ? void 0 : init.method) || 'GET';
            const body = init === null || init === void 0 ? void 0 : init.body;
            Logger.info("Doing Fetch Call");
            Logger.verbose("URL: " + url);
            Logger.verbose("Method: " + method);
            Logger.verbose("Data");
            Logger.verbose(body);
            // Don't track our own API calls
            if (url.indexOf(DataTrackingClient.getInstance().apiHost + '/api') === -1) {
                return originalFetch(input, init).then((response) => {
                    // Clone the response to read it without consuming the original
                    const clonedResponse = response.clone();
                    // Run analysis asynchronously without blocking the response
                    fetchInterceptor._analyzeFetchResponse(clonedResponse, url, method, body);
                    return response;
                }).catch((error) => {
                    Logger.error("Fetch request failed");
                    Logger.verbose(error);
                    throw error;
                });
            }
            else {
                return originalFetch(input, init);
            }
        };
    }
    _ifNeedToTrack(fetchRequest) {
        let ret = null;
        Logger.verbose("Tracking Elements =>", this._trackingItems);
        for (let i = 0; i < this._trackingItems.length; i++) {
            Logger.verbose("Matching with element");
            Logger.verbose(this._trackingItems[i]);
            if (this._trackingItems[i].formConfig) {
                if (this._checkIfRequestMatchesConfig(fetchRequest, this._trackingItems[i].formConfig, true)) {
                    ret = this._trackingItems[i];
                    break;
                }
            }
            else if (this._trackingItems[i].ajaxConfig) {
                if (this._checkIfRequestMatchesConfig(fetchRequest, this._trackingItems[i].ajaxConfig, false)) {
                    ret = this._trackingItems[i];
                    break;
                }
            }
        }
        return ret;
    }
    _checkIfRequestMatchesConfig(fetchRequest, config, isFormSubmission) {
        let shouldTrack = false;
        if (isFormSubmission) {
            Logger.info("This is a Fetch call as a part of a form submission");
        }
        else {
            Logger.info("This is a normal Fetch call");
        }
        // Handle Form submission checking                 
        if (fetchRequest._requestUrl.indexOf(config.ajaxURL) >= 0) {
            shouldTrack = true;
            if (config.formFieldName) {
                shouldTrack = false;
                Logger.info("Checking if a data key exists in the data being posted and if its value matches with the configuration");
                let fields = config.formFieldName.split(",").map((val) => { return val.replace(/^\s+|\s+$/g, ''); });
                let values = config.formFieldValue.split(",").map((val) => { return val.replace(/^\s+|\s+$/g, ''); });
                if ((fields.length != values.length)) {
                    Logger.error("Field count and value count does not match");
                }
                else {
                    if (config.dataType == "FormData") {
                        try {
                            shouldTrack = true;
                            for (let i = 0; i < fields.length; i++) {
                                if (fetchRequest._data.get(fields[i]) != values[i]) {
                                    shouldTrack = false;
                                    break;
                                }
                            }
                        }
                        catch (ex) {
                            shouldTrack = false;
                            Logger.error("FetchInterceptor:: Error in checking data key (dataType => FormData)");
                            //Logger.verbose(ex);
                        }
                    }
                    else if (config.dataType == "Object") {
                        try {
                            shouldTrack = true;
                            for (let i = 0; i < fields.length; i++) {
                                if (fetchRequest._data[fields[i]] != values[i]) {
                                    shouldTrack = false;
                                    break;
                                }
                            }
                        }
                        catch (ex) {
                            shouldTrack = false;
                            Logger.error("FetchInterceptor:: Error in checking data key (dataType => Object)");
                            //Logger.verbose(ex);
                        }
                    }
                    else if (config.dataType == "JSONString") {
                        try {
                            let tmp = JSON.parse(fetchRequest._data);
                            shouldTrack = true;
                            for (let i = 0; i < fields.length; i++) {
                                if (tmp[fields[i]] != values[i]) {
                                    shouldTrack = false;
                                    break;
                                }
                            }
                        }
                        catch (ex) {
                            shouldTrack = false;
                            Logger.error("FetchInterceptor:: Error in checking data key (dataType => JSONString)");
                            //Logger.verbose(ex);
                        }
                    }
                    else if (config.dataType == "URLSearchParams") {
                        try {
                            let params = new URLSearchParams(fetchRequest._data);
                            shouldTrack = true;
                            for (let i = 0; i < fields.length; i++) {
                                if (params.get(fields[i]) != values[i]) {
                                    shouldTrack = false;
                                    break;
                                }
                            }
                        }
                        catch (ex) {
                            shouldTrack = false;
                            Logger.error("FetchInterceptor:: Error in checking data key (dataType => URLSearchParams)");
                            //Logger.verbose(ex);
                        }
                    }
                    if (!shouldTrack) {
                        Logger.info("No matching data key found as per the configuration.");
                    }
                }
            }
            if (shouldTrack) {
                /* This fetch call is a part of a form submission, so we must check the response to see if the submission was successful. */
                Logger.info("Checking if form submission was successful");
                if (isFormSubmission && !this._checkFormSubmissionStatus(fetchRequest, config)) {
                    shouldTrack = false;
                }
            }
        }
        return shouldTrack;
    }
    _checkFormSubmissionStatus(fetchRequest, formConfig) {
        let submitSuccess = false;
        let responseText = fetchRequest.responseText;
        if (formConfig.ajaxReturnType == "json") {
            try {
                let ajaxResponse = JSON.parse(responseText);
                let success_response = Utility.getObjectValueAtPath(ajaxResponse, formConfig.ajaxSuccessJsonObject, null);
                if (success_response && success_response.indexOf(formConfig.ajaxSuccessValue) >= 0) {
                    submitSuccess = true;
                    Logger.info("Form submission was successful");
                }
                else {
                    Logger.info("Form submission was unsuccessful");
                }
            }
            catch (ex) {
                //Do nothing
                Logger.error("Error in checking response");
                Logger.verbose(ex);
            }
        }
        else if (formConfig.ajaxReturnType == "text") {
            if (responseText.indexOf(formConfig.ajaxSuccessValue) >= 0) {
                Logger.info("Form submission was successful");
                submitSuccess = true;
            }
            else {
                Logger.info("Form submission was unsuccessful");
            }
        }
        return submitSuccess;
    }
    restore() {
        if (this._originalFetch) {
            window.fetch = this._originalFetch;
        }
    }
}
FetchInterceptor._instance = null;
